import React from 'react';
import './Button.css';

/**
 * Button — componente único reutilizável
 * Consolidado: 5 formas diferentes de fazer botão nas páginas
 *
 * Uso:
 *   <Button>Confirmar</Button>
 *   <Button variant="primary">Confirmar</Button>
 *   <Button variant="danger" size="small">Deletar</Button>
 *   <Button variant="ghost" disabled>Cancelado</Button>
 */

export default function Button({
  variant = 'primary',      // primary | secondary | danger | warning | ghost | success
  size = 'md',              // sm | md | lg
  children,
  disabled = false,
  className = '',
  ...props
}) {
  const cls = `btn btn-${variant} btn-${size} ${className}`.trim();
  return (
    <button className={cls} disabled={disabled} {...props}>
      {children}
    </button>
  );
}

// Exports para uso: <Button.Small>, <Button.Danger>, etc (optional)
Button.Small = (props) => <Button size="sm" {...props} />;
Button.Large = (props) => <Button size="lg" {...props} />;
Button.Danger = (props) => <Button variant="danger" {...props} />;
Button.Ghost = (props) => <Button variant="ghost" {...props} />;
Button.Success = (props) => <Button variant="success" {...props} />;
